export enum EditEnum {

    Address = 0,
    Pickup = 1,
    Delivery = 2,
    Instruction = 3,
    PickupUpcoming = 4,
    AddressInstruction=5
}
